import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class BlogCategoryService {
  static getBlogCategories(limit = 100, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.BLOG_CATEGORY}?pageSize=${limit}&page=${page}`)
  }

  static getBlogCategory(id) {
    return ApiHelper.fetch(`${API.URL + API.BLOG_CATEGORY}/${id}`)
  }

  static addBlogCategory(blogCategory) {
    return ApiHelper.fetch(`${API.URL + API.BLOG_CATEGORY}`, {
      method: 'POST',
      body: JSON.stringify({
        blogCategory
      })
    })
  }

  static updateBlogCategory(blogCategory) {
    if (typeof blogCategory._id === 'undefined') {
      return this.addBlogCategory(blogCategory)
    }

    return ApiHelper.fetch(`${API.URL + API.BLOG_CATEGORY}/${blogCategory['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        blogCategory
      })
    })
  }

  static deleteBlogCategory(id) {
    return ApiHelper.fetch(`${API.URL + API.BLOG_CATEGORY}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default BlogCategoryService
